import React, { ReactNode } from 'react';
import { Text } from '@nbc-design/text';

export const replaceUnsupportedCharacters = (text: string): string => {
  return text.replace(/œ/g, 'oe').replace(/Œ/g, 'OE');
};

/**
 * Renders `fullText` as a `<Text>` node, wrapping the first occurrence of
 * `boldPart` in a `<b>` element. Falls back to plain `<Text>` when
 * `boldPart` is not found in `fullText`.
 *
 * `suffix` is rendered inside the same `<Text>` so it stays inline with the
 * label. Keeping it outside would make it a sibling flex item of
 * `.dsc-label__container` (`justify-content: space-between`) and push it to the
 * far edge of the row.
 */
export const renderLabelWithBold = (fullText: string, boldPart: string, suffix?: ReactNode): ReactNode => {
  const index = fullText.indexOf(boldPart);
  if (index === -1) {
    return (
      <Text>
        {fullText}
        {suffix}
      </Text>
    );
  }
  return (
    <Text>
      {fullText.slice(0, index)}
      <b>{fullText.slice(index, index + boldPart.length)}</b>
      {fullText.slice(index + boldPart.length)}
      {suffix}
    </Text>
  );
};
